// opervex-frontend/src/Opervex/ServiceManagement/index.js

import _service from "./Service";
import _serviceType from "./ServiceType";
import _serviceOrder from "./ServiceOrder";

class ServiceManagement {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.Service = new _service(this.#_api);
    this.ServiceType = new _serviceType(this.#_api);
    this.ServiceOrder = new _serviceOrder(this.#_api);
  }
}

export default ServiceManagement;
